export const SET_CITIES = 'SET_CITIES';
export const SET_CITIES_BY_PROVINCE = 'SET_CITIES_BY_PROVINCE';
